import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { TThunkAction } from '../../types/redux';
import {
  fetchLeaveContacts,
  ILeaveContactsResponse200 as IRes200,
  ILeaveContactsResponse400 as IRes400,
} from '../../repositories/e2e-deal-form/v2/leave-contacts';
import { ESentFrom } from '../../repositories/e2e-deal-form/entities/availability/LeaveContactsV2RequestSchema';

interface ILeaveContactsDeps {
  name: string;
  phone: string;
  sentFrom: ESentFrom;
}

export const leaveContacts =
  (deps: ILeaveContactsDeps): TThunkAction<Promise<void>> =>
  async (_, getState, context) => {
    const { httpApi, logger } = context;

    try {
      const result = await fetchLeaveContacts<IRes200, IRes400>({
        httpApi,
        parameters: {
          ...deps,
        },
      });

      if (result.statusCode === 200) {
        return;
      }

      throw new HttpBadStatusCodeError({
        message: `${result.response.message}`,
        domain: 'leaveContacts.ts',
        statusCode: result.statusCode,
      });
    } catch (error) {
      logger.error(error, {
        message: 'Ошибка в запросе e2e-deal-form /v2/leave-contacts/',
        domain: 'leaveContacts.ts',
        sentFrom: deps.sentFrom,
      });

      throw error;
    }
  };
